import { hideLoading, showLoading } from '../AppSlice';
import { ScenarioBatchDTO } from '../Models/ScenarioBatchModel';
// import { ScenarioModelDTO } from '../Models/ScenarioModel';
// import { ModelDTO } from './../Pages/Model/ModelList';

export const loadingDispatch = (
  dispatch: any,
  actions: Array<any>,
  onAccept: any = () => {},
  onReject: any = () => {}
) => {
  Promise.resolve(dispatch(showLoading())).then(() => {
    // Promise.all(actions.map((a) => a.unwrap()))
    Promise.all(actions)
      .then((data: any) => {
        if (data[0].meta.requestStatus === 'fulfilled') {
          onAccept();
        } else {
          onReject();
        }
      })
      // .catch((error: string) => {
      //   onReject();
      // })
      .finally(() => {
        dispatch(hideLoading());
      });
  });
};

export function makeScenarioLabel(
  scenarios: ScenarioBatchDTO[],
  // models: ModelDTO[],
  modelName: string,
  project: string
) {
  let index: number = 0;
  for (let i = 0; i < scenarios.length; i++) {
    let l = scenarios[i].label;
    if (l.includes(project)) {
      index = Math.max(index, Number(l.substring(l.lastIndexOf('_') + 1)) + 1);
    }
  }
  let modelVersion = '';
  // let modelNonBreakingVersion = '';
  // if (modelName.length === 0 && models.length > 0) {
  //   modelVersion = models[0].label.split('_')[1];
  // } else if (modelName.length > 0) {
  //   modelVersion = modelName.split('_')[1];
  // }
  // modelNonBreakingVersion = modelVersion.substring(0, modelVersion.lastIndexOf('.'));
  // return project + '_' + modelNonBreakingVersion + '_' + index.toString();
}

export const getInitials = (value: string) => {
  console.log('name', value)

  const initials = value.split(' ').map((name: string) => name[0]).join('');
  console.log('INIT', initials)
  return initials
};

export const naRender = (value: any) => {
  return value ? value : 'N/A';
};

export const naDateRender = (value: any) => {
  if (value) {
    let date = new Date(Date.parse(value));
    return date.toLocaleString();
  } else {
    return 'N/A';
  }
};

export function searchObject(query: string, ob: any, attributes: string[]): boolean {
  for (let i = 0; i < attributes.length; i++) {
    let attribute = attributes[i];
    if (!ob.hasOwnProperty(attribute)) continue;
    if (Array.isArray(ob[attribute])) {
      return ob[attribute].some((v: string) => {
        return v.toUpperCase().includes(query.toUpperCase());
      });
    }
    if (ob[attribute].toUpperCase().includes(query.toUpperCase())) return true;
  }
  return false;
}
